
export interface IWorkSheet {

    labour_id: number;

    work_type: WorkType;
    work_rate: number;
    work_count: number;
    work_total_amount: number;
    work_labour_count: number;

    description: string;
    created_by: number;
    created_date: Date;
    updated_by: number;
    updated_date: Date;
}

export interface IDailySheet {
    dailysheet_id: number;
    team_id: number;
    sheet_date: Date;
    labour_ids: number[];
    auto_update:boolean;

    worksheets: WorkSheet[];
    total_cements: number;
    total_labours: number;

    total_prod_6: number;
    total_prod_amount_6: number;

    total_shift_in_6: number;
    total_shift_out_6: number;
    total_shift_amount_6: number;

    total_load_6: number;
    total_load_amount_6: number;

    total_prod_8: number;
    total_prod_amount_8: number;

    total_shift_in_8: number;
    total_shift_out_8: number;
    total_shift_amount_8: number;

    total_load_8: number;
    total_load_amount_8: number;

    description: string;
    created_by: number;
    created_date: Date;
    updated_by: number;
    updated_date: Date;
    deleted_at: number;
}



export class DailySheet implements IDailySheet {

    dailysheet_id!: number;
    team_id!: number;
    labour_ids!: number[];
    sheet_date!: Date;
    worksheets: WorkSheet[] = [];
    total_cements!: number;
    total_labours!: number;
    auto_update =  false;

    total_prod_6!: number;
    total_prod_amount_6!: number;
    total_shift_in_6!: number;
    total_shift_out_6!: number;
    total_shift_amount_6!: number;
    total_load_6!: number;
    total_load_amount_6!: number;

    total_prod_8!: number;
    total_prod_amount_8!: number;;
    total_shift_in_8!: number;
    total_shift_out_8!: number;
    total_shift_amount_8!: number;
    total_load_8!: number;
    total_load_amount_8!: number;

    description!: string;

    created_by!: number;
    created_date!: Date;
    updated_by!: number;
    updated_date!: Date;
    deleted_at!: number;

}



export class WorkSheet implements IWorkSheet {

    constructor() {
    }

    labour_id!: number;
    // labour_name!: string;

    work_type!: WorkType;
    work_count!: number;
    work_rate!: number;
    work_labour_count = 1;
    work_total_amount!: number;

    description!: string;
    created_by!: number;
    created_date!: Date;
    updated_by!: number;
    updated_date!: Date;

}



export enum WorkType {
    PROD_6      = 'PROD_6',
    PROD_8      = 'PROD_8',

    SHIFT_IN_6  = 'SHIFT_IN_6',
    SHIFT_IN_8  = 'SHIFT_IN_8',
    SHIFT_OUT_6 = 'SHIFT_OUT_6',
    SHIFT_OUT_8 = 'SHIFT_OUT_8',

    LOAD_6      = 'LOAD_6',
    LOAD_8      = 'LOAD_8',

    UNLOAD_6    = 'UNLOAD_6',
    UNLOAD_8    = 'UNLOAD_8',
    OTHER       = 'OTHER'
}


export class WorkTypeObjects {
    public static readonly workObject:any = {
        PROD_6     :'total_prod_6',
        PROD_8     :'total_prod_8',
        SHIFT_IN_6 :'total_shift_in_6',
        SHIFT_IN_8 :'total_shift_in_8',
        SHIFT_OUT_6:'total_shift_out_6',
        SHIFT_OUT_8:'total_shift_out_8',
        LOAD_6     :'total_load_6',
        LOAD_8     :'total_load_8',
        UNLOAD_6   :'total_load_6',
        UNLOAD_8   :'total_load_8',
    }

    public static readonly workTotalAmount:any = {
      total_prod_amount_6:['PROD_6'],
      total_shift_amount_6:['SHIFT_IN_6','SHIFT_OUT_6'],
      total_load_amount_6:['LOAD_6','UNLOAD_6'],
      total_prod_amount_8:['PROD_8'],
      total_shift_amount_8:['SHIFT_IN_8','SHIFT_OUT_8'],
      total_load_amount_8:['LOAD_8', 'UNLOAD_8'],

    }

    protected static readonly workRate:any = {
        PROD_6     :3,
        PROD_8     :4,
        SHIFT_IN_6 :0.75,
        SHIFT_IN_8 :0.75,
        SHIFT_OUT_6:0.75,
        SHIFT_OUT_8:0.75,
        LOAD_6     :1,
        LOAD_8     :1.5,
        UNLOAD_6   :1,
        UNLOAD_8   :1.5,
    }

    public static readonly workTypeLable:any = {
        PROD_6     :'Total Production 6',
        PROD_8     :'Total Production 8',
        SHIFT_IN_6 :'Total Shiting in 6',
        SHIFT_IN_8 :'Total Shiting in 8',
        SHIFT_OUT_6:'Total Shiting Out 6',
        SHIFT_OUT_8:'Total Shiting Out 8',
        LOAD_6     :'Total Load 6',
        LOAD_8     :'Total Load 8',
        UNLOAD_6   :'Total UnLoad 6',
        UNLOAD_8   :'total Unload_8',
    }

    static getWorkObj(workType: WorkType) {
        return this.workObject[workType];
    }

    static getWorkRate(workType: WorkType) {
        return this.workRate[workType];
    }

    static getAllWorkObjLables() {
        return this.workObject;
    }

    static getAllWorkTypeLable() {
        return this.workTypeLable;
    }


}

export const sheetMapper =
  [
    {
      amount : 'total_prod_amount_6',
      types: ['PROD_6'],
      label: 'Total Production 6',

    },
    {
      amount : 'total_shift_amount_6',
      types: ['SHIFT_IN_6', 'SHIFT_OUT_6'],
      label: 'Total Shifting 6'
    },
    {
      amount : 'total_load_amount_6',
      types: ['LOAD_6'],
      label: 'Total Production 6'
    },
    {
      amount : 'total_prod_amount_8',
      types: ['PROD_8'],
      label: 'Total Production 8'
    },
    {
      amount : 'total_shift_amount_8',
      types: ['SHIFT_IN_8', 'SHIFT_OUT_8'],
      label: 'Total Shifting 8'
    },
    {
      amount : 'total_load_amount_8',
      types: ['LOAD_8'],
      label: 'Total Loading 8'
    }
  ]





export const WorkTypeValues = Object.keys(WorkType).map((name) => {
    return {
      name,
      value: WorkType[name as keyof typeof WorkType],
    };
  });

export class DailySheetLayout {
    activeTab       = DailSheetTab.PRODUCTION;
    availableTab    = DailSheetTab;
}

export enum DailSheetTab {
    PRODUCTION  = 'PRODUCTION',
    LABOURS     = 'LABOURS'
}

export class DailySheetSearch {
    constructor() {

    }
}


export class LoadSheet {
    load_id!: number;
    load_date!: number;
    team_id!: number;
    load_labours!: number;
    advance_amount!: number;
    total_bricks_6!: number;
    total_bricks_8!: number;
    rate_brick_6!: number;
    rate_brick_8!: number;
    description!: string;
    created_by!: number;
    created_date!: Date;
    updated_by!: number;
    updated_date!: Date;
    show_details = false;
    type ='loadsheet'
}


export class SearchSheet {
    search!: string;
    start_date!:Date;
    end_date!:Date;
    type = 'month';
    month!:number;

    constructor() {
        this.getCurrentMonthDate(new Date());
        this.month = this.getCurrentMonth();
        this.setMonthlySearch();
    }

    setMonthlySearch(){
        let date = new Date();
        date.setMonth(this.month-1);
        let data = this.getCurrentMonthDate(date);
        this.start_date = data.start_date;
        this.end_date = data.end_date;
    }

    changeSearch(search: string): void {
        this.type = search
    }

    private getCurrentMonthDate(date:Date): any {
        const firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
        const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
        return {start_date:firstDay,end_date:lastDay}
    }

    private getCurrentMonth(): number {
        var d = new Date();
        return d.getMonth() + 1;
    }
}

export class MaterialUsed {
    constructor(dailySheets:DailySheet[]){
        this.cement  = 0;
        this.brick_6 = 0;
        this.brick_8 = 0;
        dailySheets.forEach(sheet=> {
            // this.cement     = this.cement   + Number(sheet.total_cements);
            // this.brick_6    = this.brick_6  + Number(sheet.total_bricks_6);
            // this.brick_8    = this.brick_8  + Number(sheet.total_bricks_8);
        });
    }
    cement  = 0;
    brick_6 = 0;
    brick_8 = 0;

}



export interface  IWorkTypesMapper {

}


export interface IWorkTypeElement  {
  amount: string;
  types: WorkType[];
  rate: string;
  count: string[];
  label: string;
}

export class WorkTypeElement implements IWorkTypeElement{

  constructor(workElement:any) {
    try {
      this.amount = workElement.amount;
      this.types = workElement.types;
      this.rate = workElement.rate;
      this.count = workElement.count;
      this.label = workElement.label;
    } catch (error) {
    }
  }

  amount!: string;
  types!: WorkType[];
  rate!: string;
  count!: string[];
  label!: string;
}


export class WorkTypesMapper implements IWorkTypesMapper {

  workTypeElements:IWorkTypeElement[] = [];

  constructor() {
    sheetMapper.forEach(mapper => this.workTypeElements.push(new WorkTypeElement(mapper)));
    console.log(this.workTypeElements);
  }

  getAllLables(): string[] {
    let labels: string[] = [];
    try {
      this.workTypeElements.forEach(ele => labels.push(ele.label))
    } catch (error) {
    }
    return labels;
  }

}